import React, { useState, useEffect } from "react";
import { Accordion, Form, Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PDFDownloadLink } from '@react-pdf/renderer';
import { getBillingByPatient, getBillings } from "../../../apis/billing";
import { toastify } from "../../../helperFunctions/toastify";
import InvoicePDF from "../../SharedComponents/InvoicePDF";
import Table from "react-bootstrap/Table";
import NoteRenderer from "../NoteTaking/NoteRenderer";
import { getMembershipCategories } from "../../../apis/membership";
import { getInvoiceId } from "../../../helperFunctions/utils";

export default function TabBillingHistory() {
	const patientData = useSelector((state) => state.patientData.value);
	const [billings, setBillings] = useState([]);
	// const [show, setShow] = useState(false);
	const [data, setData] = useState();
	const [activeIndex, setActiveIndex] = useState();
	const [usePointVal, setUsePointVal] = useState(0);
	const [showInvoice, setShowInvoice] = useState(false);
	const [selectedBilling, setSelectedBilling] = useState({});
	const [oriBillings, setOriBillings] = useState([]);
	// const [show, setShow] = useState(false);

	const navigate = useNavigate();

	const getBillingList = async () => {
		const { result, error } = await getBillingByPatient(patientData?._id);
		if (error) {
			if (error?.message === "No data Found") {
				setBillings([]);
			} else {
				toastify(error?.message, "error");
			}
			return;
		} else {
			setOriBillings(result);
			let tempArr = result?.map((e) => {
				const loc = e?.branch?.location?.find(
					(o) => o._id === e?.location,
				);

				const packages = e?.package?.map((o) => {
					return {
						name: o?.package_id?.name,
						qty: o?.package_qty,
						price: o?.package_unit_price * o?.package_qty,
						discount: o?.package_discount,
						total_price: o?.package_price,
					};
				});
				const product = e?.product?.map((o) => {
					return {
						name: o?.product_id?.name,
						qty: o?.product_qty,
						price: o?.product_price * o?.product_qty,
						discount: o?.product_discount,
						total_price:
							o?.product_price * o?.product_qty -
							o?.product_discount,
					};
				});
				const treatment = e?.treatment?.map((o) => {
					return {
						name: o?.service_id?.name,
						qty: o?.service_qty,
						price: o?.service_unit_price * o?.service_qty,
						discount: o?.service_discount,
						total_price: o?.service_price,
					};
				});
				const others = e?.others?.map((o) => {
					return {
						name: o?.description,
						qty: 1,
						price: o?.total_price,
						discount: 0,
						total_price: o?.total_price,
					};
				});

				let taxVal = 0;
				let taxs = [];
				e?.tax?.map((tax) => {
					if (taxVal !== 0) {
						taxVal =
						tax.typeValue == "Percentage"
							? (tax.value / 100) * taxVal
							: tax.value + taxVal;
					} else {
						taxVal =
							tax.typeValue == "Percentage"
								? (tax.value / 100) * e?.actualAmount
								: tax.value + e?.actualAmount;
					}

					taxs.push({
						...tax,
						afterTaxValue: taxVal
					})
				})
				const notesObj = {
					startTime: e?.session?.startTime,
					endTime: e?.session?.endTime,
					staff: e?.session?.staff?.map((o) => o?.username),
					soap: e?.session?.patientSOAP,
					location: loc,
					service: [...packages, ...product, ...treatment, ...others],
					remarks: e?.remarks,
					usePoints: e?.usePoints,
					promo: e?.promo,
					tax: e?.tax,
					promoDiscount: (e?.promo / 100) * e?.actualAmount,
					afterTaxValue: taxVal,
					gstAmount: e?.gst,
					actualAmount: e?.actualAmount,
					totalAmount: e?.totalAmount,
					paymentMethod: e?.paymentMethod?.name,
					installmentRecord: e.isPaymentInInstallment ? e.paymentRecord : null,
				};
				return {
					date: new Date(e.created_at).toLocaleDateString(),
					notes: notesObj,
					_id: e._id,
					invoiceNo: e.invoiceNo,
					updated_at: e.updated_at,
					totalAmount: e.totalAmount,
					gstAmount: e?.gst,
				};
			});
			tempArr = tempArr.reverse();
			setBillings(tempArr);
		}
		// if (response?.status !== "Fail") {
		// 	// let _response = response?.filter(
		// 	// 	(e) => patientData?._id === e?.patient?._id,
		// 	// );

		// 	setBillings(_response);
		// 	console.log({ _response });
		// } else {

		// }
	};

	useEffect(() => {
		if (data) {
			console.log(data);
		}
	}, [data]);

	useEffect(() => {
		getBillingList();
		(async () => {
			const res = await getMembershipCategories();
			if (res?.status !== "Fail") {
				setUsePointVal(0);
				return;
			}
			setUsePointVal(res?.point);
		})();
	}, []);

	return (
		<div className="billing-data-table">
			<Table striped bordered>
				<thead
					style={{
						background: "#24566f",
						color: "white",
					}}
				>
					<tr>
						<th className="wd-150">Invoice No</th>
						<th className="wd-100">Date</th>
						<th className="wd-100">Total Amount</th>
						<th className="wd-100">Total Amount (GST)</th>
						<th className="ps-5 wd-100">Actions</th>
					</tr>
				</thead>
				<tbody>
					{billings?.map((e, index) => (
						<>
							<tr>
								<td className="wd-150">
									{e.invoiceNo
										? getInvoiceId(e.invoiceNo)
										: "-"}
								</td>
								<td className="wd-100">
									{new Date(
										e.updated_at,
									).toLocaleDateString()}
								</td>
								<td className="wd-100">{e.totalAmount}</td>
								<td className="wd-100">{e.gstAmount}</td>
								<td className="wd-100">
									<button
										className="addItem-billing"
										style={{ display: "inline-block", marginRight: "20px" }}
										onClick={() => {
											if (index === activeIndex) {
												setActiveIndex();
												setData();
											} else {
												setActiveIndex(index);
												setData(e);
											}
										}}
									>
										View Details
									</button>
									<button
										className="addItem-billing"
										style={{ display: "inline-block", width: "100px" }}
										onClick={() => {
											setSelectedBilling(oriBillings[index]);
											setShowInvoice(true);
										}}
									>
										Print
									</button>
								</td>
							</tr>
							{activeIndex === index && (
								<tr>
									<td colSpan="4">
										<NoteRenderer
											role={"Doctor"}
											isPatientBilling
											patientProfile={
												patientData.patientProfile
											}
											updated_at={e?.updated_at}
											notes_data={e.notes}
											date={e.date}
											pointVal={usePointVal}
											isBilling={true}
										/>
									</td>
								</tr>
							)}
						</>
					))}
				</tbody>
			</Table>

			{
				showInvoice && (
					<Modal
						centered
						show={showInvoice}
						onHide={() => {
							setShowInvoice(false);
						}}
						size="sm"
					>
						<Modal.Header closeButton>
							<Modal.Title id="contained-modal-title-vcenter">
								Invoice
							</Modal.Title>
						</Modal.Header>

						<div className="pdf-btn">
							<PDFDownloadLink document={<InvoicePDF billing={selectedBilling} />} fileName="Invoice.pdf">
								{({ blob, url, loading, error }) =>
									loading ? 'Loading document...' : 'Download PDF'
								}
							</PDFDownloadLink>
						</div>
					</Modal>
				)
			}
		</div>
	);
}
